// extracted by css-extract-rspack-plugin
module.exports =  {"container":"Colors-PXla__container","visible-colors-container":"Colors-brhT__visible-colors-container"};